import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: SarinManS
 * id 678BDE48-30CE-4897-BA06-9991001FA842
 * name barn
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/barn.svg
 * tags
 * - Agriculture 
 */
export const BarnIcon = createSvgIcon(<><path d="M12,3L3,8.2V21H9L11.9,18L15,21H21V8.2L12,3M7.9,20V14L10.9,17L7.9,20M8.9,13H14.9L11.9,16L8.9,13M15.9,20L12.9,17L15.9,14V20M15,11H8.8V9H15V11Z" /></>, 'BarnIcon');
export default BarnIcon